import { createSelector } from '@reduxjs/toolkit';
import type { RequirementsState } from 'admin/src/reducers/pollworker/requirements';
import type { AppState } from 'admin/src/store';

export const selectRequirementsSlice = (state: AppState): RequirementsState => state.pollworker.requirements;

export const selectRequirementsItems = createSelector(selectRequirementsSlice, (slice) => slice.items);

export const selectRequirementsLoading = createSelector(selectRequirementsSlice, (slice) => slice.loading);

export const selectRequirementsLoadingMore = createSelector(selectRequirementsSlice, (slice) => slice.loadingMore);

export const selectRequirementsFilters = createSelector(selectRequirementsSlice, (slice) => slice.filters);

export const selectRequirementsTotalCount = createSelector(selectRequirementsSlice, (slice) => slice.totalCount);

export const selectRequirementsPageSize = createSelector(selectRequirementsSlice, (slice) => slice.pageSize);

export const selectRequirementsHasMore = createSelector(selectRequirementsSlice, (slice) => slice.hasMore);

export const selectRequirementsViewSelectedSessionId = (state: AppState) => state.pollworker.requirementsView.selectedSessionId;

const selectSessionIdArg = (_state: AppState, sessionId: string | null | undefined) => sessionId ?? null;

export const selectSessionDetailById = createSelector([selectRequirementsSlice, selectSessionIdArg], (slice, sessionId) => {
  if (!sessionId) return null;
  return slice.sessionDetailsById[sessionId] || null;
});

export const makeSelectSessionAttendees = () =>
  createSelector([selectRequirementsSlice, selectSessionIdArg], (slice, sessionId) => {
    if (!sessionId) return [];
    const ids = slice.attendeeIdsBySession[sessionId] || [];
    return ids.map((id) => slice.attendeesById[id]).filter(Boolean);
  });

export const selectLoadingSession = createSelector(selectRequirementsSlice, (slice) => slice.loadingSession);

export const selectLoadingAttendees = createSelector(selectRequirementsSlice, (slice) => slice.loadingAttendees);

export const selectLoadingLmsCompletion = createSelector(selectRequirementsSlice, (slice) => slice.loadingLmsCompletion);

export const selectSessionLmsCompletionById = createSelector([selectRequirementsSlice, selectSessionIdArg], (slice, sessionId) => {
  if (!sessionId) return null;
  return slice.lmsCompletionBySessionId[sessionId] || null;
});

export const selectWorkerOptions = createSelector(selectRequirementsSlice, (slice) => slice.workerOptions);

export const selectLoadingWorkerOptions = createSelector(selectRequirementsSlice, (slice) => slice.loadingWorkerOptions);
